// Mixins
import { orderMixins } from '@/app/mixins/modules/order-mixins';

export default {
	name: 'OrdersPendingContainer',
	mixins: [ orderMixins ],
	data() {
		return {
			theads: [
				{ name: 'Order Number', searchLabel: 'f_id', sortLabel: 'createdAt', isDesc: false, hasSearch: true, style: null},
				{ name: 'User', searchLabel: 'f_fullName', sortLabel: 'fullName', isDesc: false, hasSearch: true, style: null},
				{ name: 'Address', searchLabel: 'f_shippingAddress', sortLabel: 'shippingAddress', isDesc: false, hasSearch: true, style: null},
				{ name: 'Pet', searchLabel: 'f_petName', sortLabel: 'petName', isDesc: false, hasSearch: true},
				{ name: 'Breed', searchLabel: 'f_breedName', sortLabel: 'breedName', isDesc: false, hasSearch: true},
				{ name: 'Price', searchLabel: 'f_totalPrice', sortLabel: 'totalPrice', isDesc: false, hasSearch: true},
				{ name: 'Status', isDesc: false, hasSearchableDropdown: false},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: 'width: 170px'}
			]
		}
	}
}